import { useContext } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { QueryCallbacks } from "../shared/interfaces/ReactQuery";
import { useMutation } from "react-query";
import { ResultComment } from "../shared/interfaces/ResultComments";

export function useResultCommentUpdate(captureId: number, callbacks?: QueryCallbacks<number>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["resultCommentUpdate", captureId],
    async (comment: Partial<ResultComment>) => apiContext.resultsApis.updateResultComments(captureId, comment),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
